export default {"src":"/_next/static/media/box_64.8226fdd8.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};